import { Icon, type IconName } from "@/components/icon/Icon";

const STEPS: Array<{ verb: string; icon: IconName; body: string }> = [
  {
    verb: "건네요",
    icon: "send",
    body: "링크나 QR을 영수증, 테이블, 문자에 붙여요. 손님은 앱을 깔거나 가입하지 않아요.",
  },
  {
    verb: "골라요",
    icon: "circleCheck",
    body: "손님이 좋았던 점을 누르고, 아쉬웠던 점이 있으면 그것도 골라요. 고른 사실만 초안에 들어가요.",
  },
  {
    verb: "고쳐요",
    icon: "pencil",
    body: "초안 세 개 중 하나를 골라 손님이 자기 말로 다듬어요. 고칠수록 그 사람의 후기가 돼요.",
  },
  {
    verb: "올려요",
    icon: "arrowUpRight",
    body: "글이 복사되고 붙여 넣는 순서가 나와요. 손님이 자기 계정으로 별점과 함께 직접 올려요.",
  },
];

export function HowItWorks() {
  return (
    <section id="how" aria-labelledby="how-title" className="scroll-mt-20">
      <div className="mx-auto grid max-w-layout gap-10 px-5 py-20 md:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] md:gap-16">
        <div className="md:sticky md:top-24 md:self-start">
          <h2 id="how-title" className="wds-title-2 text-label-strong break-keep">
            링크 하나만 건네면 돼요
          </h2>
          <p className="mt-4 max-w-sm text-body-1 font-regular text-label-neutral break-keep">
            후기를 남길까 망설이던 손님이 1분 안쪽으로 끝내는 것을 목표로 만들었어요.
          </p>
          {/* TODO(image): photo of a printed Tellvue QR table tent on a real cafe table, 4:3, about 960x720, warm daylight. Place below this paragraph on md+ only. */}
        </div>
        <ol className="flex flex-col">
          {STEPS.map((s, i) => (
            <li
              key={s.verb}
              className={`flex gap-5 py-7 ${i > 0 ? "shadow-[inset_0_1px_0_var(--line-normal-neutral)]" : ""}`}
            >
              <span className="mt-1 inline-flex h-11 w-11 flex-none items-center justify-center rounded-md bg-fill-normal text-label-normal">
                <Icon name={s.icon} size={22} />
              </span>
              <div className="min-w-0">
                <h3 className="wds-heading-1 text-label-strong">{s.verb}</h3>
                <p className="mt-2 text-body-1 font-regular text-label-neutral break-keep">
                  {s.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
